import React from 'react';
import { components } from 'react-select';

// tslint:disable-next-line: no-any
export const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        className="w-4 h-4"
        width="18"
        height="11"
        viewBox="0 0 18 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.1193 0.991019C16.9542 0.994917 16.7974 1.06396 16.6831 1.18308L8.99995 8.86618L1.31685 1.18308C1.25859 1.12308 1.18888 1.07539 1.11186 1.04282C1.03484 1.01025 0.952066 0.993464 0.868441 0.993461C0.744057 0.993491 0.62251 1.03063 0.519352 1.10013C0.416194 1.16962 0.336116 1.26832 0.289364 1.38358C0.242612 1.49885 0.231312 1.62544 0.25691 1.74716C0.282508 1.86888 0.343839 1.9802 0.433056 2.06687L8.55806 10.1919C8.67527 10.309 8.83422 10.3748 8.99995 10.3748C9.16568 10.3748 9.32463 10.309 9.44184 10.1919L17.5668 2.06687C17.6577 1.97963 17.7201 1.86697 17.7459 1.74366C17.7716 1.62034 17.7595 1.49212 17.7111 1.37581C17.6627 1.2595 17.5803 1.16052 17.4747 1.09186C17.3691 1.02319 17.2452 0.988044 17.1193 0.991019Z"
          fill="currentColor"
        />
      </svg>
    </components.DropdownIndicator>
  );
};
